import { MenuRow, SettingCard } from '@components/Dashboard/components'
import type { AccountFormHandler } from '@components/Dashboard/pages/Account/types'
import { Globe as GlobeIcon } from '@octopus-do/octopus-storybook/icons'
import type { AccountData } from '@store/reducers/account'
import type React from 'react'

import countries from '@/constants/countries.json'
import { Divider } from '../../../../components/Divider'

interface Props {
  state: AccountData
  onChange: AccountFormHandler
}

const countryOptions = countries.map((item) => ({
  label: item.name,
  value: item.name,
}))

const timeFormatOptions = [
  { value: 'HH:MM XM', label: '12h AM/PM' },
  { value: 'HH:MM', label: '24h' },
]

const dateFormatOptions = [
  { value: 'DD-MM-YYYY', label: 'DD-MM-YYYY' },
  { value: 'MM-DD-YYYY', label: 'MM-DD-YYYY' },
]

export const RegionSection: React.FC<Props> = ({ state, onChange }) => (
  <SettingCard title="Region">
    <MenuRow
      label="Country"
      value={state.country}
      options={countryOptions}
      onChange={onChange('country')}
      icon={GlobeIcon}
    />

    <Divider />

    <MenuRow
      label="Time format"
      value={state.timeFormat}
      options={timeFormatOptions}
      onChange={onChange('timeFormat')}
    />

    <Divider />

    <MenuRow
      label="Date format"
      value={state.dateFormat}
      options={dateFormatOptions}
      onChange={onChange('dateFormat')}
    />
  </SettingCard>
)
